import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'activity-accommodation-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './activity-accommodation-dialog.component.html',
  styleUrl: './activity-accommodation-dialog.component.scss'
})
export class ActivityAccommodationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ActivityAccommodationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { items: any[] }
  ) {}

  selectItem(item: any): void {
    this.dialogRef.close(item);
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
